import { render, staticRenderFns } from "./template-select.vue?vue&type=template&id=8e36f5c6"
import script from "./template-select.vue?vue&type=script&lang=js"
export * from "./template-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports